export const VpOperationsSidebarData = [
  {
    title: "TECHNICAL SUPPORT",
    link: "technicalsupport",
  },
  {
    title: "ADMISSION - EDUTECH",
    subNav: [
      {
        title: "BATCHWISE COUNT",
        path: "cxoBatchwiseCount",
        cName: "sub-nav",
      },
      {
        title: "DATEWISE COUNT",
        path: "datewisecount",
        cName: "sub-nav",
      },
      {
        title: "REVENUE DETAILS",
        path: "revenuedetails",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DOUBT SOLVE REVIEW",
    link: "doubtsolvereview",
  },
  {
    title: "ENROLLED EDUTECH",
    link: "transactionedutech",
  },
  {
    title: "ENROLLED EDUTECH STUDYMATERIAL",
    link: "transactionEdutechStudyMaterial",
  },
  {
    title: "REGISTRATION DETAILS",
    link: "registrationdetails",
  },
  {
    title: "PACKAGE DETAILS",
    subNav: [
      {
        title: "EXTRA/OLD PACKAGE EXISTS",
        path: "oldPackageExist",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE DUPLICATE URL",
    link: "youtubeDuplicateUrl",
  },
  {
    title: "INFLUENCER PAYMENT",
    link: "influencerPayment",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];

export const VpOperationsEmpSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TECHNICAL SUPPORT",
    link: "technicalsupport",
  },
  {
    title: "ADMISSION - EDUTECH",
    subNav: [
      {
        title: "BATCHWISE COUNT",
        path: "cxoBatchwiseCount",
        cName: "sub-nav",
      },
      {
        title: "DATEWISE COUNT",
        path: "datewisecount",
        cName: "sub-nav",
      },
      {
        title: "REVENUE DETAILS",
        path: "revenuedetails",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DOUBT SOLVE REVIEW",
    link: "doubtsolvereview",
  },
  {
    title: "ENROLLED EDUTECH",
    link: "transactionedutech",
  },
  {
    title: "ENROLLED EDUTECH STUDYMATERIAL",
    link: "transactionEdutechStudyMaterial",
  },
  {
    title: "REGISTRATION DETAILS",
    link: "registrationdetails",
  },
  {
    title: "PACKAGE DETAILS",
    subNav: [
      {
        title: "EXTRA/OLD PACKAGE EXISTS",
        path: "oldPackageExist",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE DUPLICATE URL",
    link: "youtubeDuplicateUrl",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "INFLUENCER PAYMENT",
    link: "influencerPayment",
  },
];
